//https://github.com/rexxars/react-markdown
import React from "react"
import ReactMarkdown from "react-markdown"

import { Title, Paragraph } from "components/atoms/Typography"
import Box from "components/atoms/Box"

// TODO: Add components for lists, links, images, etc.
const MarkdownParagraph = ({ children, color }) => (
  <Paragraph color="inherit" mb={4}>
    {children}
  </Paragraph>
)
const MarkdownTitle = ({ level, children }) => (
  <Title variant={`h${level}`}>{children}</Title>
)

const renderers = {
  paragraph: MarkdownParagraph,
  heading: MarkdownTitle,
}

const Markdown = ({ source, color, ...rest }) => {
  return (
    <Box {...rest}>
      <ReactMarkdown source={source} renderers={renderers} />
    </Box>
  )
}

export default Markdown
